import {
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
    STOP_LOCATION_FETCH,
    FETCH_BOOKING_TRAIL_SUCCESS,
    STORE_ADRESSES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { query, onValue, set, off, push, limitToLast, update } from "firebase/database";
import { shouldPersistUserLocation, shouldPersistTrackingPoint } from '../other/locationThrottler';
import { buildDriverLocationPayload } from '../other/LiveVehicleTracking';

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;
    if (!bookingId || !location || location.lat == null || location.lng == null) return;
    if (!shouldPersistTrackingPoint(bookingId, location.lat, location.lng)) {
        return;
    }
    try {
        // El rechazo (p. ej. PERMISSION_DENIED si el viaje ya no pertenece al
        // conductor) debe capturarse, de lo contrario aparece la caja roja
        // "Operación no completada" y se interrumpe el seguimiento/ruta.
        const p = push(trackingRef(bookingId), location);
        if (p && typeof p.catch === 'function') p.catch((e) => { console.log('saveTracking error', e); });
    } catch (e) { console.log('saveTracking error', e); }
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
    onValue(query(trackingRef(bookingId), limitToLast(80)), (snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const sortedKeys = Object.keys(data).sort();
            const trail = sortedKeys
                .map((key) => data[key])
                .filter((point) => point && point.lat != null && point.lng != null);

            dispatch({
                type: FETCH_BOOKING_TRAIL_SUCCESS,
                payload: trail,
            });

            if (trail.length >= 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: trail[trail.length - 1],
                });
            } else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_TRAIL_SUCCESS,
                payload: [],
            });
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

export const fetchAssignedDriverLocation = (driverId) => (dispatch) => {
    const { userLocationRef } = firebase;
    if (!driverId) return;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: driverId,
    });

    onValue(userLocationRef(driverId), (snapshot) => {
        const val = snapshot.val();
        if (val && val.lat != null && val.lng != null) {
            dispatch({
                type: FETCH_BOOKING_LOCATION_SUCCESS,
                payload: {
                    lat: val.lat,
                    lng: val.lng,
                    heading: val.heading,
                    speed: val.speed,
                    updatedAt: val.updatedAt || Date.now(),
                },
            });
        }
    });
};

export const stopAssignedDriverLocation = (driverId) => () => {
    if (!driverId) return;
    const { userLocationRef } = firebase;
    off(userLocationRef(driverId));
};

export const saveUserLocation = (location, options = {}) => {
    const {
      auth,
      userLocationRef,
    } = firebase;
    const uid = auth && auth.currentUser && auth.currentUser.uid;
    if (!uid || !location || location.lat == null || location.lng == null) return;
    if (!options.force && !shouldPersistUserLocation(
        location.lat,
        location.lng,
        options.mode || (options.isActiveService ? 'active' : 'idle')
    )) {
        return;
    }
    try {
        const payload = buildDriverLocationPayload(location, {
            isOnline: options.isOnline,
            isOnTrip: options.isOnTrip,
            bookingId: options.bookingId,
            vehicleType: options.vehicleType,
            status: options.status,
        });
        const p = set(userLocationRef(uid), payload);
        if (p && typeof p.catch === 'function') p.catch((e) => { console.log('saveUserLocation error', e); });
    } catch (e) { console.log('saveUserLocation error', e); }
}

export const storeAddresses = (data) => (dispatch) => {
    dispatch({
        type: STORE_ADRESSES,
        payload: data,
    });
}

/** Marca al conductor como offline sin borrar su última coordenada. */
export const markDriverLocationOffline = (uid) => {
    const { userLocationRef } = firebase;
    if (!uid) return;
    try {
        const p = update(userLocationRef(uid), { isOnline: false, updatedAt: Date.now() });
        if (p && typeof p.catch === 'function') p.catch(() => { });
    } catch (e) { }
}